import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, timeout: 90000 });

export const api = {
  getList: () => client.get("/shopping-list").then((r) => r.data),
  importRecipe: (url, portions) =>
    client.post("/import-recipe", { url, portions }).then((r) => r.data),
  addRecipe: (recipe_name, ingredients) =>
    client.post("/shopping-list/add-recipe", { recipe_name, ingredients }).then((r) => r.data),
  addItem: (item, recipe_name = "") =>
    client
      .post(`/shopping-list/add-item?recipe_name=${encodeURIComponent(recipe_name)}`, item)
      .then((r) => r.data),
  updateItem: (id, patch) =>
    client.put(`/shopping-list/item/${id}`, patch).then((r) => r.data),
  deleteItem: (id) => client.delete(`/shopping-list/item/${id}`).then((r) => r.data),
  resetList: () => client.post("/shopping-list/reset").then((r) => r.data),
  createShare: () => client.post("/shopping-list/share").then((r) => r.data),
  getShared: (shareId) => client.get(`/shopping-list/shared/${shareId}`).then((r) => r.data),
  getMascots: () => client.get("/mascots").then((r) => r.data),
};

export const RAYONS = ["Fruits & Légumes", "Crèmerie", "Épicerie", "Boucherie", "Autre"];
export const UNITS = ["g", "kg", "ml", "cl", "l", "pièce", "c. à s.", "c. à c.", "tasse", "gousse", "pincée"];

export const RAYON_META = {
  "Fruits & Légumes": { emoji: "🥕", color: "#A3B18A", bg: "rgba(163, 177, 138, 0.12)" },
  "Crèmerie": { emoji: "🧈", color: "#E5C07B", bg: "rgba(229, 192, 123, 0.15)" },
  "Épicerie": { emoji: "🌾", color: "#B08968", bg: "rgba(176, 137, 104, 0.12)" },
  "Boucherie": { emoji: "🥩", color: "#E07A5F", bg: "rgba(224, 122, 95, 0.12)" },
  "Autre": { emoji: "🍯", color: "#8A817C", bg: "rgba(138, 129, 124, 0.12)" },
};
